import script from "./questionsDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./questionsDetails.vue?vue&type=script&lang=ts&setup=true"

import "./questionsDetails.vue?vue&type=style&index=0&id=53a65a97&lang=less&scoped=true"

import exportComponent from "D:\\officialWebsite\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53a65a97"]])

export default __exports__